<script setup lang="ts">
  import { useAuthStore } from '@/stores/auth';
  import { useEnvironmentsStore } from '@/stores/environments';
  import { pickAllowedLocale, setLocale } from '@/utils/locale';

  const errorStatus = ref(null);
  const environmentsStore = useEnvironmentsStore();
  const authStore = useAuthStore();
  const { locale } = useI18n();

  const applyAllowedLocale = () => {
    const allowed = (environmentsStore.LANGUAGES ?? []).map((language) => language.code);
    const next = pickAllowedLocale(locale.value, allowed, environmentsStore.DEFAULT_LANGUAGE ?? '');
    if (next) {
      locale.value = next;
      setLocale(next);
    }
  };

  onBeforeMount(async () => {
    try {
      await environmentsStore.getEnvironments();
      applyAllowedLocale();
    } catch (error: any) {
      if (authStore.isAuthorized.value) {
        errorStatus.value = error.response?.status || error.status;
      }
    }
  });
</script>

<template>
  <VToast />
  <RouterView v-if="!errorStatus" />
  <VErrorLayout v-else :status="errorStatus" />
</template>
